module.exports = __webpack_public_path__ + "img/orga-logo.83d28d97.png";